import axios from 'axios'

// state
export const state = {
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  setHowToPlayModalVisibility(state, { isVisible }) {
    state.isHowToPlayVisible = isVisible
  },
}
// actions
export const actions = {
  changeLanguage({ commit, rootState: { auth: { token } } }, { lang }) {
    if (token) {
      axios.post('profile/changeLanguage', {
        language: lang,
      })
    }
  },
}
